import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { GenericLink as n } from "@nextgen-web-framework/all";
import './assets/CategoryItemContainer.css';const r = "#ffffff", d = "#396e75", c = "#e5fdff", g = "#546223", m = "#f0fae5", s = "#a65523", _ = "#fff1e8", h = "#7f3e3e", u = "#ffe2e2", z = "#62625a", V = "#f8f8e7", f = "#38539a", k = "#707070", C = "#c8f8d1", y = "#87c9c8", w = "#5291b1", B = "rgba(82, 145, 177, 0.1019607843)", b = "#445685", G = "#181d61", v = "rgba(24, 29, 97, 0.1019607843)", O = "#5969d6", p = "#ea999d", R = "#b6577e", W = "rgba(182, 87, 126, 0.1019607843)", Y = "#7e3e80", x = "#1e247f", I = "rgba(30, 36, 127, 0.1019607843)", M = "#da7600", N = "#107f47", $ = "#d91734", j = "_html_1ltig_75", A = "_activeMenu_1ltig_332", i = {
  amwayWhite: r,
  darkBlue: d,
  lightBlue: c,
  darkGreen: g,
  lightGreen: m,
  darkOrange: s,
  lightOrange: _,
  darkRed: h,
  lightRed: u,
  darkYellow: z,
  lightYellow: V,
  darkPurple: f,
  darkGrayOnWhite: k,
  dataVizColor1: C,
  dataVizColor2: y,
  dataVizColor3: w,
  dataVizColor3Background: B,
  dataVizColor4: b,
  dataVizColor5: G,
  dataVizColor5Background: v,
  dataVizColor6: O,
  dataVizColor7: p,
  dataVizColor8: R,
  dataVizColor8Background: W,
  dataVizColor9: Y,
  dataVizColor10: x,
  dataVizColor10Background: I,
  dataVizAlertOrange: M,
  dataVizSuccessGreen: N,
  dataVizWarningRed: $,
  "no-visible": "_no-visible_1ltig_34",
  html: j,
  "header-item-list": "_header-item-list_1ltig_142",
  "link-menu-wrapper": "_link-menu-wrapper_1ltig_168",
  "megamenu-title-container": "_megamenu-title-container_1ltig_187",
  "megamenu-title": "_megamenu-title_1ltig_187",
  "megamenu-icon": "_megamenu-icon_1ltig_208",
  "amway-header-megamenu-modal": "_amway-header-megamenu-modal_1ltig_225",
  "ahm-content-full": "_ahm-content-full_1ltig_242",
  "ahm-on-scroll": "_ahm-on-scroll_1ltig_256",
  "ahm-list": "_ahm-list_1ltig_262",
  "megamenu-col": "_megamenu-col_1ltig_272",
  "megamenu-category-title": "_megamenu-category-title_1ltig_276",
  "category-item-title": "_category-item-title_1ltig_300",
  "highlighted-category": "_highlighted-category_1ltig_324",
  activeMenu: A,
  "fade-in": "_fade-in_1ltig_1",
  "fade-out": "_fade-out_1ltig_349",
  "slide-down": "_slide-down_1ltig_353",
  "active-link-label": "_active-link-label_1ltig_393",
  "link-menu-label": "_link-menu-label_1ltig_397"
}, L = (a) => {
  var l;
  return /* @__PURE__ */ o("section", { className: i["megamenu-col"], "data-testid": "category-item", "data-pod-name": "commerce", children: [
    a.category.title && /* @__PURE__ */ e("div", { className: i["megamenu-category-title"], "data-testid": "megamenu-category-title-testId", "data-pod-name": "commerce", children: a.category.title }),
    /* @__PURE__ */ e("ul", { children: (l = a.category.subCategories) == null ? void 0 : l.map((t) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e(
      n,
      {
        href: t.url,
        className: `${i["category-item-title"]} ${t.highlighted ? i["highlighted-category"] : ""}`,
        "data-testid": "generic-link-testId",
        "data-pod-name": "commerce",
        target: t.target,
        children: t.title
      }
    ) }, t.title)) })
  ] }, `${a.category.title}`);
};
export {
  L as C,
  i as s
};
//# sourceMappingURL=CategoryItemContainer-08fe9cf5.mjs.map
